export { default } from './loyalty-offers';
export { default as LoyaltyOffers } from './loyalty-offers';
